import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import TaskIcon from "@mui/icons-material/Task";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import ApplicationStore from "../../../utils/localStorageUtil";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import AddIcon from "@mui/icons-material/Add";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import PrintIcon from "@mui/icons-material/Print";
import ReactDOMServer from "react-dom/server";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import axios from "../../../api/axios";
import PDFPrint from "./PDFPrint";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Grid } from "@mui/material";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
const URL = "./dealership/getPending";

function ViewPendingWarranty() {
  const { sidebarItemIndex, setSidebarItemIndex } = useAuthContext();
  const userName = ApplicationStore().getStorage("userName");
  const [vinSearch, setVinSearch] = useState(""); // State for VIN search input
  const [lastName, setLastName] = useState(""); // State for VIN search input
  const user = ApplicationStore().getStorage("user_email");
  const userType = ApplicationStore().getStorage("user_type");
  const [dealership, setDealership] = useState(
    userType === "admin" ? 0 : ApplicationStore().getStorage("dealership"),
  );
  const [dealershipValue, setDealershipValue] = useState(""); // State for VIN search input
  const [dealershipText, setDealershipText] = useState(""); // State for VIN search input
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [alertOpen, setAlertopen] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [trigger, setTrigger] = useState(false); // State to trigger useEffect

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const handleClick = () => {
    setAlertopen(true);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertopen(false);
  };

  const [dealershipArray, setDealershipArray] = useState([]);
  const handleDealership = (newvalue) => {
    if (newvalue) {
      console.log("value", newvalue.id);
      setDealershipValue(newvalue.id);
      setDealershipText(newvalue.accountName);
    } else {
      setDealershipValue();
    }
  };

  const loadDealership = async () => {
    try {
      const URL = "./dealership";
      const response = await axios.get(URL);

      if (response.data.status === 401) {
        setDealershipArray(""); // Keep dummy data in case of unauthorized response
      } else {
        const responseData = response.data.data;
        // const dataWithIndex = response.data.data.map((item, index) => ({
        //     ...item,
        //     slNo: index + 1, // Assign sequential SL No starting from 1
        // })) || "";
        setDealershipArray(responseData);
      }
    } catch (err) {
      console.log("Error fetching data:", err);
      // Use dummy data if request fails
      setDealershipArray("");
    }
  };

  // useEffect that runs after the `trigger` changes
  useEffect(() => {
    if (trigger) {
      console.log("useEffect is triggered by the action!");
      // Perform side effects here (e.g., fetching data, updating the DOM)

      // Reset trigger to avoid continuous execution
      setTrigger(false);
    }
    loadData();
    loadDataVin();
    loadDealership();
  }, [trigger]); // Dependency on `trigger` state

  const navigate = useNavigate();

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const serviceMethod = async (
    mainURL,
    method,
    data,
    handleSuccess,
    handleException,
  ) => {
    try {
      const response = await axios.post(mainURL, data);
      return handleSuccess(response.data);
    } catch (err) {
      if (!err?.response) {
        console.log("No server response");
      } else {
        return handleException(err?.response.data);
      }
    }
  };

  const handleSuccess = (data) => {
    console.log("data response", data);
    setSeverity("success");
    setMessage(data.data);
    setAlertopen(true);
    setTimeout(() => {
      setTrigger(true); // This will trigger useEffect
      setAlertopen(false);
    }, 3000); // Matches autoHideDuration
  };

  const convertImageToBase64 = async () => {
    // Make sure the image path is relative to the public folder
    const response = await fetch(`${process.env.PUBLIC_URL}/carCanadaNew.png`);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(blob);
    });
  };

   const formatDate = (date) => {
    if (!date) return "";

    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) return "";

    return parsedDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    });
  };

  const handleException = (data) => {
    console.log("data error", data);
    setSeverity("error");
    setMessage(data.data);
    setAlertopen(true);
    setTimeout(() => {
      setTrigger(true); // This will trigger useEffect
      setAlertopen(false);
    }, 3000); // Matches autoHideDuration
  };

  const columns = [
    { field: "slNo", headerName: "SL No", width: 100 },
    {
      field: "customerName",
      headerName: "Customer Name",
      width: 250,
      valueGetter: (params) =>
        `${params.row.customerFirstName || ""} ${params.row.customerLastNameText || ""
          }`.trim(),
    },
    { field: "vinNo", headerName: "VIN No", width: 200 },
    { field: "make", headerName: "Selected Vehicle", width: 200 },
    { field: "warrantyClassText", headerName: "Package Type", width: 200 },
    { field: "user", headerName: "Dealer Salesperson", width: 200 },
    // { field: "id", headerName: "Internal ID", width: 100 },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 250,
      cellClassName: "actions",
      getActions: (params) => {
        return userType == "admin"
          ? [
            // <EditData selectedRow={params.row}/>,
            // <DeleteData selectedRow={params.row} />,
            <CopyData selectedRow={params.row} />,
            <EditData selectedRow={params.row} />,
            <DeleteData selectedRow={params.row} />,
            <PrintData selectedRow={params.row} />,
          ]
          : [
            // <EditData selectedRow={params.row}/>,
            // <DeleteData selectedRow={params.row} />,
            <CopyData selectedRow={params.row} />,
            <EditData selectedRow={params.row} />,
            <DeleteData selectedRow={params.row} />,
            <PrintData selectedRow={params.row} />,
          ];
      },
    },
  ];

  const PDFPrintNew = ({ data }) => {
    return (
      <div style={{ width: "100%" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            tableLayout: "fixed", // Ensure fixed table layout for equal width
          }}
        >
          <tr>
            <td rowSpan="6" style={{ border: "1px solid black", width: "50%" }}>
              First Column Spanning Rows
            </td>
            <td style={{ border: "1px solid black", width: "50%" }}>
              Application ID: 2409136013
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>
              Application ID: 2409136013
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>
              Application ID: 2409136013
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>
              Application ID: 2409136013
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>
              Application ID: 2409136013
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>
              Application ID: 2409136013
            </td>
          </tr>
        </table>
      </div>
    );
  };
 const generatePdf = async (data, applicationId) => {
     console.log("data" + JSON.stringify(data));
     const LOGO = await convertImageToBase64();
 
     // Render the PDFPrint component as static HTML
     // const componentHtml = ReactDOMServer.renderToStaticMarkup(<PDFPrintNew />);
 
     // Convert the HTML content to pdfMake format
     // const pdfContent = htmlToPdfmake(componentHtml, { window });
 
     // Create the PDF document definition using the converted content
 
     const text = data.productName;
 
     let dealershipaddress = "";
 
     var tradeName = "";
     var billingStreet = "";
     var billingCity = "";
     var billingCountry = "";
     var billingZippostalCode = "";
     var ovmic_no = "";
     var accountPhone = "";
     var acc_ovmic_no = "";
 
     try {
       const response = await axios.get(
         "dealership/" + data.dealership + "/fetch",
       );
 
       if (response.data.success === 500) {
         console.error("Server error: Failed to fetch dealership data.");
         // Handle the error appropriately, e.g., show an alert or return early
         return;
       }
 
       const responseData = response.data.data;
       if (responseData) {
         const dealershipaddress = JSON.stringify(responseData[0]); // Converts object to string
         const dealershipData = JSON.parse(dealershipaddress); // Parse it back to an object
 
         if (dealershipData?.tradeName) tradeName = dealershipData.tradeName;
         if (dealershipData?.billingStreet)
           billingStreet = dealershipData.billingStreet;
         if (dealershipData?.billingCity)
           billingCity = dealershipData.billingCity;
         if (dealershipData?.billingCountry)
           billingCountry = dealershipData.billingCountry;
         if (dealershipData?.billingZippostalCode)
           billingZippostalCode = dealershipData.billingZippostalCode;
         if (dealershipData?.ovmic_no) ovmic_no = dealershipData.ovmic_no;
         if (dealershipData?.accountPhone)
           accountPhone = dealershipData.accountPhone;
         if (dealershipData?.acc_ovmic_no)
           acc_ovmic_no = dealershipData.acc_ovmic_no;
       }
     } catch (error) {
       console.error("An error occurred while fetching dealership data:", error);
     }
 
     let warrantySold = parseFloat(
       data.salePriceofVehicle.replace(/,/g, ""),
     ).toFixed(2);
     // let warrantySold = data.salePriceofVehicle;
 
     let kilometers = "";
     let customerNM =
       data.customerFirstNameText + " " + data.customerLastNameText;
     let user = data.user.split("@");
     const monthsMatch = text.match(/\((\d+)\s*months/i);
     let Months = monthsMatch ? parseInt(monthsMatch[1], 10) + " Months" : "-";
 
     const inserviceDate = new Date(data.serviceDateText);
     const formattedDatefmt = formatDate(data.serviceDateText);
 
     const vehicleWarrantyEndDate = new Date(data.vehicleWarrantyEndDate);
     const formattedDatefmtVW = formatDate(data.vehicleWarrantyEndDate);
 
     const batteryDriveUnitWarrantyEndDate = new Date(
       data.batteryDriveUnitWarrantyEndDate,
     );
     const formattedDatefmtBDW = formatDate(data.batteryDriveUnitWarrantyEndDate);
 
     const vehicleDeliveryDate = new Date(data.vehicleDeliveryDate);
     const vehicleDeliveryDatefmt = vehicleDeliveryDate.toLocaleDateString(
       "en-US",
       { year: "numeric", month: "long", day: "2-digit" },
     );
 
     // Extract Kilometers
     if (text.includes("/")) {
       let kmMatch = text.split("/");
       if (kmMatch.length > 1) {
         kilometers = kmMatch[1].split(")")[0].trim();
       }
     }
 
     let applicationtitle = "";
 
     if (data.warrantyClass == 26) {
       applicationtitle = "Application for Loan Deficiency Coverage";
     } else if (data.packages == 4) {
       applicationtitle = "Application for EV Warranty Coverage";
     } else {
       applicationtitle = "Application for Warranty Coverage";
     }
 
     const docDefinition = {
       pageSize: "A4",
       pageMargins: [20, 20, 20, 20],
       content: [
         // First Table
         {
           table: {
             widths: ["50%", "50%"], // Set the width for each column
             body: [
               [
                 {
                   image: LOGO, // Use the 'image' key for the logo
                   rowSpan: 6,
                   fit: [150, 150], // Adjust size as needed
                   border: [false, false, false, false],
                 },
                 {
                   text: `Application ID: ${data.id}`,
                   border: [false, false, false, false],
                   fontSize: 10,
                   alignment: "right",
                   bold: true,
                 },
               ],
               [
                 "",
                 {
                   text: `Warranty Status: ${data.Status}`,
                   border: [false, false, false, false],
                   fontSize: 10,
                   alignment: "right",
                   bold: true,
                 },
               ],
               [
                 "",
                 {
                   text: `Warranty Price: $${parseFloat(
                     data.warrantySoldFor,
                   ).toFixed(2)}`,
                   border: [false, false, false, false],
                   fontSize: 10,
                   alignment: "right",
                   bold: true,
                 },
               ],
               ["", { text: ``, border: [false, false, false, false] }],
               ["", { text: ``, border: [false, false, false, false] }],
               [
                 {
                   text: "Application for GAP Bundle Warranty Coverage",
                   rowSpan: 3,
                   border: [false, false, false, false],
                   fontSize: 10,
                   alignment: "right",
                   bold: true,
                 },
                 {
                   text: `455 Bowes Road, Unit 4A Concord, ON L4K 1J5, \n Phone: 905.291.2940`,
                   border: [false, false, false, false],
                   fontSize: 10,
                   alignment: "right",
                   bold: true,
                 },
               ],
 
               [
                 {
                   text: "A Division of Car Deals Direct Inc. Registration #4963229 \n\n Get Covered Canada",
                   border: [false, false, false, false],
                   fontSize: 10,
                   bold: true,
                 },
                 {
                   text: "claims@getcoveredcanada.ca",
                   border: [false, false, false, false],
                   fontSize: 10,
                   alignment: "right",
                   bold: true,
                 },
               ],
               [
                 {
                   text: `${applicationtitle}`,
                   border: [false, false, false, false],
                   fontSize: 10,
                   bold: true,
                 },
                 {
                   text: "www.getcoveredcanada.ca",
                   border: [false, false, false, false],
                   fontSize: 10,
                   alignment: "right",
                   bold: true,
                 },
               ],
             ],
           },
         },
         { text: "\n" }, // Add spacing between the tables
         {
           table: {
             widths: ["100%"], // Adjust the column widths for this table
             body: [
               [
                 {
                   text: "Customer Details",
                   border: [false, false, false, false],
                   bold: true,
                   alignment: "left",
                   fontSize: 10,
                 },
               ],
             ],
           },
         },
         // { text: '\n' }, // Add spacing between the tables
         {
           table: {
             widths: ["100%"], // Adjust the column widths for this table
             body: [
               [
                 {
                   text: "",
                   border: [false, false, false, true],
                   bold: true,
                   alignment: "left",
                   fontSize: 10,
                 },
               ],
             ],
           },
         },
         {
           table: {
             widths: ["20%", "30%", "20%", "30%"], // Adjust the column widths for this table
             body: [
               // [
               //     { text: 'Customer details', border: [false, false, false, false],fontSize: 10, bold: true },
               //     { text: '', border: [false, false, false, false] },
               //     { text: '', border: [false, false, false, false] },
               //     { text: '', border: [false, false, false, false] },
               // ],
               [
                 {
                   text: `Customer First Name:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${data.customerFirstNameText}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: `Address: `,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${data.streetAddressText}\n ${data.townText},  ${data.provinceText},  ${data.postalCodeText}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                   alignment: "left",
                 },
               ],
               [
                 {
                   text: `Customer Last Name:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${data.customerLastNameText}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
               ],
               [
                 {
                   text: `Drivers Licence:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${data.driverLicenceText}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: `Email:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${data.customerEmailText}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
               ],
               [
                 {
                   text: `Phone:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${data.customerPhone}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
               ],
             ],
           },
         },
         { text: "\n" }, // Add spacing between the tables  townText. provinceText. postalCodeText
         {
           table: {
             widths: ["100%"], // Adjust the column widths for this table
             body: [
               [
                 {
                   text: "Vehicle Details",
                   border: [false, false, false, false],
                   bold: true,
                   alignment: "left",
                   fontSize: 10,
                 },
               ],
             ],
           },
         },
         // { text: '\n' }, // Add spacing between the tables
         {
           table: {
             widths: ["100%"], // Adjust the column widths for this table
             body: [
               [
                 {
                   text: "",
                   border: [false, false, false, true],
                   bold: true,
                   alignment: "left",
                   fontSize: 10,
                 },
               ],
             ],
           },
         },
 
         // Second Table
         {
           table: {
             widths: ["20%", "30%", "20%", "30%"], // Adjust the column widths for this table
             body: [
               [
                 {
                   text: `Year:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${data.year}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: `Sale Price:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 // { text: `$ ${warrantySold}`, border: [false, false, false, false], fontSize: 8, bold: false }
                 {
                   text: `$${Number(warrantySold).toLocaleString(undefined, {
                     minimumFractionDigits: 2,
                     maximumFractionDigits: 2,
                   })} `,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
               ],
               [
                 {
                   text: `Make:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${data.make}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
               ],
 
               [
                 {
                   text: `Model:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${data.model}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: `Vehicle Delivery Date:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${vehicleDeliveryDatefmt == "Invalid Date"
                     ? ""
                     : vehicleDeliveryDatefmt
                     }`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
               ],
 
               [
                 {
                   text: `VIN:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${data.vinNoText}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: `In Service Date:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${formattedDatefmt == "Invalid Date" ? "" : formattedDatefmt
                     }`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
               ],
 
 
               [
                 {
                   text: `${data.isElectricHybridVehicle === "No" || data.isElectricHybridVehicle === null
                     ? "" : "Vehicle Warranty End Date:"}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${formattedDatefmtVW == "Invalid Date"
                     ? ""
                     : formattedDatefmtVW
                     }`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: `${data.isElectricHybridVehicle === "No" || data.isElectricHybridVehicle === null
                     ? "" : "Battery & Drive Unit Warranty End Date:"}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${formattedDatefmtBDW == "Invalid Date"
                     ? ""
                     : formattedDatefmtBDW
                     }`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
               ],
 
 
 
 
               [
                 {
                   text: `Odometer:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${parseInt(data.odometerText.replace(/,/g, ""), 10).toLocaleString()} KM`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: `Finance Company:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${data.financeCompanyText}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
               ],
             ],
           },
         },
 
         { text: "\n" }, // Add spacing between the tables
         {
           table: {
             widths: ["100%"], // Adjust the column widths for this table
             body: [
               [
                 {
                   text: "Warranty Details",
                   border: [false, false, false, false],
                   bold: true,
                   alignment: "left",
                   fontSize: 10,
                 },
               ],
             ],
           },
         },
         // { text: '\n' }, // Add spacing between the tables
         {
           table: {
             widths: ["100%"], // Adjust the column widths for this table
             body: [
               [
                 {
                   text: "",
                   border: [false, false, false, true],
                   bold: true,
                   alignment: "left",
                   fontSize: 10,
                 },
               ],
             ],
           },
         },
 
         // Second Table
         {
           table: {
             widths: ["20%", "30%", "20%", "30%"], // Adjust the column widths for this table
             body: [
               [
                 {
                   text: `Warranty Plan:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${data.productName.replace("(", "  (")}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: `Deductible:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `$${(data.productName ===
                     "3 month term / 3,000km distance $1,000 Coverage(3 Months or 3,000 KM)"
                     ? 100
                     : Number(data.deductible || 0)
                   ).toFixed(2)}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
               ],
 
               [
                 {
                   text: `Max Protection:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${data.warrantyProtectionText}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: `Roadside:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `None`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
               ],
               // [
               //     { text: '\n', colSpan: 4, border: [false, false, false, false] }, {}, {}, {}
               // ],
 
               [
                 {
                   text: `Warranty Length:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${Months}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
               ],
 
               [
                 {
                   text: `Coverage:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${kilometers}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
               ],
             ],
           },
         },
 
         { text: "\n" }, // Add spacing between the tables
 
         {
           text: "Terms", // Heading
           style: { fontSize: 10, bold: true, margin: [0, 10, 0, 10] }, // Style for the heading
         },
         {
           ul:
             data.packages == 4
               ? [
                 // EV Package
                 "I, the Buyer, have read, selected, understand, and accept the terms and conditions of the Warranty Application and the Warranty Policy as outlined in the following pages and have retained a copy of the application and acknowledge that the selling dealer has made no representation outside the Terms and Conditions.",
                 "I understand any abuse, misuse, or neglect of my vehicle may lead to my claims being denied. I understand that I must keep maintenance records and receipts of the maintenance performed as I may be asked to submit these records if a claim is submitted to Get Covered Canada.",
                 "I understand repairs made to covered components without prior authorization by Get Covered Canada will not be reimbursed. Claims cannot be submitted after the completion of required work.",
                 "I hereby certify that all of the information set out herein is true and accurate. I am applying for coverage at the time of the vehicle purchase or prior to the expiration of an existing full manufacturer’s warranty and the vehicle is in proper operating condition at the date of the application. Misleading or False Information will void warranty coverage.",
                 "I understand that any aftermarket modifications made to the vehicle, including but not limited to performance, engine, suspension, electrical, or other non-manufacturer-approved modifications, will void the warranty coverage in its entirety.",
                 "I understand and agree that for the first thirty-six (36) days following the vehicle purchase date, the selling dealership is solely responsible for addressing any mechanical issues or repairs covered under applicable dealership obligations. During this period, any concerns must first be reported to and inspected by the selling dealership. Coverage under this Warranty Policy becomes effective after the initial thirty-six (36) day period, subject to the terms, conditions, and exclusions of this agreement.",
                 "I understand and agree that for the first thirty- six (36) days following the vehicle purchase date, the selling dealership is solely responsible for addressing any safety issues or repairs covered under applicable dealership obligations. During this period, any concerns must first be reported to and inspected by the selling dealership. Coverage under this Warranty Policy becomes effective after the initial thirty-six (36) day period, subject to the terms, conditions, and exclusions of this agreement",
               ]
               : data.warrantyClass == 26
                 ? [
                   //GAP
                   "I, the Buyer, have read, selected, understand, and accept the terms and conditions of the Warranty Application and the Warranty Policy as outlined in the following pages and have retained a copy of the application and acknowledge that the selling dealer has made no representation outside the Terms and Conditions.",
                   "I, understand and agree that it is my obligation to maintain the vehicle according to the manufacturer’s guidelines, including changing your vehicle's engine oil and the oil filter every 10,000km or six months (whichever comes first) by/at a licensed mechanic shop/oil service centre (such as Mr. Lube or Active Green + Ross) and monitoring and changing other fluids according to the manufacturer’s guidelines, and section 3 of this agreement.",
                   "I understand any abuse, misuse, or neglect of my vehicle may lead to my claims being denied. I understand that I must keep maintenance records and receipts of the maintenance performed as I may be asked to submit these records if a claim is submitted to Get Covered Canada.",
                   "I understand that maintenance must be performed by licensed mechanics or maintenance shops. Do-it-yourself oil changes are not accepted.",
                   "I understand repairs made to covered components without prior authorization by Get Covered Canada will not be reimbursed. Claims cannot be submitted after the completion of required work.",
                   "I hereby certify that all of the information set out herein is true and accurate. I am applying for coverage at the time of the vehicle purchase or prior to the expiration of an existing full manufacturer’s warranty and the vehicle is in proper operating condition at the date of the application. Misleading or False Information will void warranty coverage.",
                 ]
                 : [
                   "I, the Buyer, have read, selected, understand, and accept the terms and conditions of the Warranty Application and the Warranty Policy as outlined in the following pages and have retained a copy of the application and acknowledge that the selling dealer has made no representation outside the Terms and Conditions.",
                   "I, understand and agree that it is my obligation to maintain the vehicle according to the manufacturer’s guidelines, including changing your vehicle's engine oil and the oil filter every 10,000km or six months (whichever comes first) by/at a licensed mechanic shop/oil service centre (such as Mr. Lube or Active Green + Ross) and monitoring and changing other fluids according to the manufacturer’s guidelines, and section 3 of this agreement.",
                   "I understand any abuse, misuse, or neglect of my vehicle may lead to my claims being denied. I understand that I must keep maintenance records and receipts of the maintenance performed as I may be asked to submit these records if a claim is submitted to Get Covered Canada.",
                   "I understand that maintenance must be performed by licensed mechanics or maintenance shops. Do-it-yourself oil changes are not accepted.",
                   "I understand repairs made to covered components without prior authorization by Get Covered Canada will not be reimbursed. Claims cannot be submitted after the completion of required work.",
                   "I hereby certify that all of the information set out herein is true and accurate. I am applying for coverage at the time of the vehicle purchase or prior to the expiration of an existing full manufacturer’s warranty and the vehicle is in proper operating condition at the date of the application. Misleading or False Information will void warranty coverage.",
                   "I understand that any aftermarket modifications made to the vehicle, including but not limited to performance, engine, suspension, electrical, or other non-manufacturer-approved modifications, will void the warranty coverage in its entirety.",
                   "I understand and agree that for the first thirty-six (36) days following the vehicle purchase date, the selling dealership is solely responsible for addressing any mechanical issues or repairs covered under applicable dealership obligations. During this period, any concerns must first be reported to and inspected by the selling dealership. Coverage under this Warranty Policy becomes effective after the initial thirty-six (36) day period, subject to the terms, conditions, and exclusions of this agreement.",
                   "I understand and agree that for the first thirty- six (36) days following the vehicle purchase date, the selling dealership is solely responsible for addressing any safety issues or repairs covered under applicable dealership obligations. During this period, any concerns must first be reported to and inspected by the selling dealership. Coverage under this Warranty Policy becomes effective after the initial thirty-six (36) day period, subject to the terms, conditions, and exclusions of this agreement",
                 ],
           fontSize: 8,
           margin: [15, 5, 0, 0],
           border: [true, true, true, true],
           alignment: "justify",
         },
         { text: "\n" }, // Add spacing between the tables
 
         {
           table: {
             widths: ["25%", "5%", "70%"], // Adjust the column widths for this table
             body: [
               [
                 {
                   text: `Applicant's Signature:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: `Salesperson's Signature:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
               ],
               [
                 {
                   text: `X`,
                   border: [false, false, false, true],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `X`,
                   border: [false, false, false, true],
                   fontSize: 8,
                   bold: false,
                 },
               ],
             ],
           },
         },
         {
           table: {
             widths: ["30%", "40%", "30%"], // Adjust the column widths for this table
             body: [
               [
                 {
                   text: `Customer Name:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `Salesperson:`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 {
                   text: `Salesperson #:${data.useromvicno}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
               ],
               [
                 {
                   text: `${customerNM}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `${user[0].toUpperCase()}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
               ],
             ],
           },
         },
         {
           table: {
             widths: ["30%", "70%"], // Adjust the column widths for this table
             body: [
               [
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
                 {
                   text: `I, the representative of the selling Dealer, certify that the named used vehicle is mechanically fit`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
               ],
             ],
           },
         },
         {
           table: {
             widths: ["30%", "40%", "30%"], // Adjust the column widths for this table
             body: [
               [
                 {
                   text: ``,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: true,
                 },
 
                 // { text: `${tradeName} \n ${billingStreet} \n ${billingCity} \n ${billingCountry} \n  ${billingZippostalCode}`, border: [false, false, false, false], fontSize: 8, bold: false },
                 {
                   text: `${tradeName}`,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
                 // { text: `Reg #: ${ovmic_no} \n Phone: ${accountPhone}`, border: [false, false, false, false], fontSize: 8, bold: false },
                 {
                   text: `Reg #: ${acc_ovmic_no} \n `,
                   border: [false, false, false, false],
                   fontSize: 8,
                   bold: false,
                 },
               ],
             ],
           },
         },
         { text: "\n" }, // Add spacing between the tables
 
         ...(data.warrantyClass == 26
           ? [
             {
               text: "",
               // text: 'Policy Terms and Conditions',
               style: { fontSize: 8, bold: false, margin: [0, 10, 0, 10] },
             },
           ]
           : [
             {
               // text: 'Terms and Conditions',
               text: "",
               style: { fontSize: 8, bold: false, margin: [0, 10, 0, 10] },
             },
           ]),
 
         ...(data.warrantyClass == 26
           ? [
             {
               text: [
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Loan Deficiency Coverage Program – Terms & Conditions \n`,
                   margin: [0, 5],
                   bold: true,
                   fontSize: 20,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Issued by: GET COVERED CANADA INC. \n`,
                   margin: [0, 5],
                   bold: true,
                   fontSize: 8,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Updated: August 2025 \n\n`,
                   margin: [0, 5],
                   bold: true,
                   fontSize: 8,
                 },
                 {
                   fontSize: 13,
                   alignment: "left",
                   text: `Section 1 - Definitions \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Applicant: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The individual listed on the application who is also the registered owner of the vehicle.\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Application: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The form submitted to Get Covered Canada for Loan Deficiency Coverage coverage/proection, certified by the applicant as accurate and complete, and attached to this policy.\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Claim: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `A formal request for coverage under this policy, made by the policy holder.\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Commercial Purposes: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Use of the financed or purchased vehicle for business-related activities including, but not limited to: transporting goods or passengers for compensation, security services, taxi or ride-sharing (e.g. UBER, Lyft), school or public buses, police or emergency use, and vehicles insured under a commercial policy. Personal use under a commercial policy by a sole driver is not considered “Commercial Use.”\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Covered Vehicle: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The motor vehicle, recreational vehicle, trailer, or watercraft listed on the application and licensed for use solely under the applicatant.\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Covered Vehicle Purchase Price: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The reasonable purchase price of the covered vehicle (excluding taxes and excessive fees), as listed in the original financing or lease agreement/contract.\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Date of Loss: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The actual date when the vehicle is declared a 'Total Loss' due to damage or theft, by the police or insurance provider of the policy holder.\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Dealer: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The selling dealership as named in the application\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Deductible: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The $199.00 amount deducted from a Loan Deficiency Coverage payout/claim to cover administrative costs.\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Down-Payment Amount: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The cash or trade-in equity paid by the applicant, as listed in the application. It does not include any financed portion of the trade-in vehicle.\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Equity Trade-in Amount: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The value of a traded-in vehicle (not including any outstanding balance), as reflected in the bill of sale or lease agreement.\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Finance Contract: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The original loan or lease agreement between the policy holder and the finance company.\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Finance Contract Amount: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The full amount financed as specified in the application on page one\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Finance Contract Term: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The duration of the finance contract, as stated in the application on page one\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Finance Company: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The lender or leasing company listed in the application on page one\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Loss: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The difference between the outstanding balance of the finance contract at the date of loss, and the 'Actual Cash Value' (ACV) of the covered vehicle as determined by the primary policy insurer. Certain items are excluded from this balance, including overdue payments, future interest, taxes, unpaid premiums, and other specified fees or deductions\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Policy: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `This Loan Deficiency Coverage contract, including the first page of the application and the terms and conditions\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Policy Holder: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The applicant(s) listed on page one of the application, only if the policy has been issued and the individual(s) are also named on the finance contract\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Policy Period: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The shorter of either 96 months or the stated finance contract term noted on page one\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Primary Policy: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The underlying auto or property insurance policy that provides physical damage coverage for said covered vehicle on the application\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Primary Policy Insurer: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The insurance company that issued the primary policy on the covered vehicle\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Proof of Loss: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Documentation submitted by the policy holder to support a claim, which may include a police report, loan agreement, valuation report, and/or other required records\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Total Loss: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `An incident covered by the primary policy resulting in either:\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Irreparable damage exceeding the vehicle’s ACV: \n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Theft with the vehicle deemed non-recoverable\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Total Premium: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The full Loan Deficiency Coverage premium listed on the first page of the application, paid by the applicant via a licensed OMVIC dealership to GET COVERED CANADA INC.\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Vehicle Valuation Report: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `A settlement breakdown from the primary policy insurer showing how the ACV was calculated on/at the 'date of loss'.\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `VIN: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The unique 17-digit Vehicle Identification Number listed on the application.\n\n\n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Section 2 – Coverage \n`,
                   margin: [0, 5],
                   bold: true,
                   fontSize: 13,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Upon full payment of the total premium and subject to a valid claim being paid by the primary insurer, coverage is provided as follows: \n`,
                   margin: [0, 5],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `A. Loan Deficiency Coverage Coverage \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `GET COVERED CANADA INC. will pay the difference between: \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 The outstanding balance on the finance contract as of the date of loss, and \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 The Actual Cash Value (ACV) as determined by the primary insurer \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: true,
                   text: [
                     {
                       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Coverage Limit `,
                       bold: true,
                       fontSize: 8,
                     },
                     {
                       text: ` - As stated on the first page of the application/contract \n\n`,
                       fontSize: 8,
                     },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `B. Partial Loss Deductible Reimbursement \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     {
                       text: `If the covered vehicle is involved in an at-fault accident that results in a `,
                       fontSize: 8,
                     },
                     { text: `partial loss: \n`, bold: true, fontSize: 8 },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     {
                       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 We will reimburse the policy holder for the collision deductible charged by the primary insurer, up to`,
                       fontSize: 8,
                     },
                     { text: ` $1,000 \n`, bold: true, fontSize: 8 },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     {
                       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Only`,
                       fontSize: 8,
                     },
                     { text: ` one claim`, bold: true, fontSize: 8 },
                     {
                       text: ` may be made under this coverage for the life of the policy \n\n`,
                       fontSize: 8,
                     },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `C. Maximum Payout\n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `The total benefits paid under Sections 2A and 2B combined will not exceed the limit stated on the first page of this application/contract. \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     { text: `Note:`, fontSize: 8, bold: true },
                     {
                       text: ` All Loan Deficiency Coverage payouts are made directly to the finance company/lender by GET COVERED CANADA Inc.\n\n`,
                       fontSize: 8,
                     },
                   ],
                 },
 
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `D. Deductible: \n`,
                   margin: [0, 5],
                   bold: true,
                 },
 
                 // {
                 //     fontSize: 8, alignment: 'left', text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022   All policies are subject to a $200.00CDN deductible. \n `, margin: [0, 5], bold: false
                 // },
 
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	All policies are subject to a $199.00CDN deductible. \n`,
                   margin: [0, 5],
                   bold: false,
                 },
 
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	All claims are subject to a 10% clawback amount deducted from the total claim amount; the clawback is processed prior to the $199.00 deductible \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\   being subtracted. \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022   Prices are subject to change without prior notice. \n\n\n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022   Prices are subject to change without prior notice. \n\n\n`,
                   margin: [0, 5],
                   bold: false,
                 },
 
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Section 3 – Exclusions \n`,
                   margin: [0, 5],
                   bold: true,
                   fontSize: 13,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     { text: `This Policy does `, fontSize: 8 },
                     { text: `not `, bold: true, fontSize: 8, italics: true },
                     {
                       text: `provide coverage for any of the following: \n `,
                       fontSize: 8,
                     },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 If no down-payment coverage was selected\n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Any promises or coverage not specifically included in Section 2\n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Consequential or indirect damages, including loss due to negligence or fraud\n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Any losses caused by criminal activity (charges being laid) or where charges were laid under the Highway Traffic Act, to any party in the covered \n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 vehicle at the time of the accident/incident \n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Misrepresentation of any kind, and where alcohol or drug use was involved – determined at the time of the claim, incident, or any time thereafter by\n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 the police and/or by a credible investigation team\n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Use of the vehicle for commercial (where/when not permitted), governmental, or racing purposes/use\n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Vehicles older than eleven (11) model years at the time of application\n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     {
                       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Loan amounts exceeding the`,
                       fontSize: 8,
                     },
                     { text: ` Loan-to-Value (LTV)`, fontSize: 8, bold: true },
                     { text: ` limit noted in the policy\n `, fontSize: 8 },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Excessive vehicle pricing, unreasonable fees, or cashback amounts\n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 War, rebellion, or civil unrest\n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Mechanical or electrical failure\n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Use in races, contests, or stunt events\n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Loss due to the use of custom parts, after-market parts, and/or specialized equipment\n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Providing false information on the application, later in time, or during a claim process\n `,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Claims reported more than 5 days after the date of loss (total loss dated to be determined by the applicant’s automotive insurance company)\n `,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Any loss caused by a primary insurance deductible\n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Total loss vehicles & Rebuilt vehicles are not eligible\n\n\n`,
                   margin: [0, 5],
                   bold: false,
                 },
 
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Section 4 – Claims Process \n`,
                   margin: [0, 5],
                   bold: true,
                   fontSize: 13,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `A. Notice of Loss \n `,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 You must notify GET COVERED CANADA INC. in writing within 5 business days from the date of loss – date of vehicle being determined as a “total \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 loss vehicle” is determined and considered the legal date (for all purposes) by the applicant’s automotive insurance company. \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `B. Proof of Loss  \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 You must submit the required documentation in writing to GET COVERED CANADA Inc. within 5 business days of the date of the applicant’s vehicle\n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 being deemed/determines as a ‘total loss’. \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 //   {
                 //     fontSize: 8,
                 //     alignment: "left",
                 //     margin: [0, 5],
                 //     bold: false,
                 //     text: [
                 //       {
                 //         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 5 business days of the date of the applicant’s vehicle being deemed/determines as a ‘total loss’`,
                 //         fontSize: 8,
                 //         bold: true,
                 //       },
                 //       // { text: ` or \n`, fontSize: 8 },
                 //     ],
                 //   },
                 //   {
                 //     fontSize: 8,
                 //     alignment: "left",
                 //     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 30 days after your initial automotive insurance claim date/notice \n`,
                 //     margin: [0, 5],
                 //     bold: true,
                 //   },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Documentation may include your insurance settlement, police report, finance agreement, valuation report, etc... deemed acceptable by Get Covered\n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 Canada and/or their representatives \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `C. Claim Review & Payment  \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     {
                       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Claims will be reviewed within`,
                       fontSize: 8,
                     },
                     { text: ` 30 days`, fontSize: 8, bold: true },
                     {
                       text: ` of receiving satisfactory documentation. If approved, the payment will be made directly to the finance\n`,
                       fontSize: 8,
                     },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 company/lender  \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `D. Duty to Minimize Loss  \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `You are responsible for taking reasonable steps to: \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Protect the vehicle at all times from damage or theft \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Maximize your primary insurer’s payout \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     {
                       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 `,
                       fontSize: 8,
                     },
                     { text: `Note:`, fontSize: 8, decoration: "underline" },
                     {
                       text: ` Failure to do so may reduce the benefits paid under this policy \n\n\n`,
                       fontSize: 8,
                     },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Section 5 – Termination  \n`,
                   margin: [0, 5],
                   bold: true,
                   fontSize: 13,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `A. Cancelling the Policy (Applicant)  \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `You may cancel by sending written notice to GET COVERED CANADA INC., (using the email address: claims@getcoveredcanada.ca) stating your desired cancellation date and reason  \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `B. Refund Within 10 Business Days – by applicant  \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     {
                       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 If cancelled by the applicant within`,
                       fontSize: 8,
                     },
                     { text: ` 10 business days`, fontSize: 8, bold: true },
                     { text: ` of purchase,`, fontSize: 8 },
                     {
                       text: ` the applicant will receive a full refund`,
                       fontSize: 8,
                       bold: true,
                       italics: true,
                     },
                     { text: ` of the total premium \n`, fontSize: 8 },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `C. Cancellation After 10 Business Days – by applicant \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     {
                       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 If cancelled`,
                       fontSize: 8,
                     },
                     {
                       text: ` after`,
                       fontSize: 8,
                       bold: true,
                       italics: true,
                     },
                     { text: ` 10 business days`, fontSize: 8, bold: true },
                     {
                       text: ` from the date of purchase, the applicant will receive,`,
                       fontSize: 8,
                     },
                     {
                       text: ` no refund (partial or full)  \n`,
                       fontSize: 8,
                       bold: true,
                       italics: true,
                     },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `D. Cancellation - by Insurer  \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     {
                       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 The insurer or GET COVERED CANADA INC. may cancel this policy with at least`,
                       fontSize: 8,
                     },
                     {
                       text: ` 15 days' written notice.  \n`,
                       fontSize: 8,
                       bold: true,
                     },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `E. Refund - Upon Insurer Cancellation  \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     {
                       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 If your policy is cancelled by the insurer or Get Covered Canada you will receive a`,
                       fontSize: 8,
                     },
                     { text: ` pro-rated refund`, fontSize: 8, bold: true },
                     {
                       text: ` for the unused portion, subject to any minimum \n`,
                       fontSize: 8,
                     },
                   ],
                 },
                 {
                   fontSize: 8,
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 retained premium  \n`,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `F. Termination Timing  \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022   `,
                   margin: [0, 5],
                   bold: false,
                   text: [
                     {
                       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Cancellation is effective at`,
                       fontSize: 8,
                     },
                     {
                       text: ` 12:01 a.m. (Standard Time)`,
                       fontSize: 8,
                       bold: true,
                     },
                     {
                       text: ` on the listed termination date  \n`,
                       fontSize: 8,
                     },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `G. Notice Delivery  \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Notices are considered delivered once sent via registered mail to the address listed on the policy  \n\n\n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `Section 6 – General Provisions & Notices \n`,
                   margin: [0, 5],
                   bold: true,
                   fontSize: 13,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `A. Communications \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 All correspondence must be sent by registered mail. Either party may update their address via written notice \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `B. Subrogation \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 If the Insurer or GET COVERED CANADA INC. pays a claim, they may pursue recovery from third parties. The policy holder must assist in this process \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `C. Recoveries \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 If you receive any other compensation related to a covered claim, that amount must be reimbursed to GET COVERED CANADA INC. or the insurer \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `D. Other Insurance \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 This policy pays only after other valid automotive insurance is exhausted \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `E. Privacy \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     {
                       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 GET COVERED CANADA INC. complies with`,
                       fontSize: 8,
                     },
                     { text: ` PIPEDA`, fontSize: 8, bold: true },
                     {
                       text: ` and only collects or shares personal information as necessary to: \n`,
                       fontSize: 8,
                     },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Process applications and claims \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Detect fraud \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Meet legal requirements \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Data may be stored outside Canada and accessible to foreign authorities. Security safeguards are in place, but absolute protection cannot be \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 guaranteed \n \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     { text: `For `, fontSize: 8 },
                     { text: `all `, fontSize: 8, bold: true, italics: true },
                     {
                       text: `inquiries, please contact Get Covered Canada by email: `,
                       fontSize: 8,
                     },
                     {
                       text: `claims@getcoveredcanada.ca `,
                       fontSize: 8,
                       decoration: "underline",
                     },
                     { text: `or by phone to: 905-291-2940 \n`, fontSize: 8 },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `F. Currency \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   margin: [0, 5],
                   bold: false,
                   text: [
                     {
                       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 All reported quotes, fees, transactions, etc... and dollar amounts are written in`,
                       fontSize: 8,
                     },
                     {
                       text: ` Canadian Dollars. \n`,
                       fontSize: 8,
                       bold: true,
                     },
                   ],
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `G. Third-Party Rights \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Only the policy holder is entitled to policy benefits \n`,
                   margin: [0, 5],
                   bold: false,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: `H. Governing Law \n`,
                   margin: [0, 5],
                   bold: true,
                 },
                 {
                   fontSize: 8,
                   alignment: "left",
                   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 This policy is governed by the provincial laws of the province of Ontario (Get Covered Canada's province of business) and the federal laws of Canada. \n`,
                   margin: [0, 5],
                   bold: false,
                 },
               ],
             },
           ]
           : data.packages == 4
             ? [
               {
                 text: [
                   // {
                   //     fontSize: 8, alignment: 'left', text: `Extended Warranty Program – Terms & Conditions \n`, margin: [0, 5], bold: true
                   // },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Extended Warranty Program – Terms & Conditions \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 20,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Issued by: GET COVERED CANADA INC. \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 8,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Updated: August 2025 \n\n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 8,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Extended Warranty Agreement Overview \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ The full Agreement includes both the Extended Warranty Application/Registration Page & Terms and Conditions of the policy \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Only documents provided to the policy holder directly by Get Covered Canada are valid \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Please keep a copy as proof of coverage for the full term of the policy \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Only listed parts, labour, and specified benefits are covered \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   // {
                   //     fontSize: 8, alignment: 'left', text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ This is an Inclusionary Mechanical Breakdown Warranty, not a service agreement or contract \n\n\n`, margin: [0, 5], bold: false
                   // },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: " \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0 This is an ",
                         fontSize: 8,
                       },
                       {
                         text: "Inclusionary Mechanical Breakdown Warranty, ",
                         bold: true,
                         italics: true,
                         fontSize: 8,
                       },
                       {
                         text: "not a service agreement or contract \n\n\n",
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `1. Essential Warranty Plans \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0 Get Covered Canada Inc. will cover reasonable repair costs for `,
                         fontSize: 8,
                       },
                       {
                         text: `Covered Parts `,
                         bold: true,
                         italics: true,
                         fontSize: 8,
                       },
                       { text: `due to`, fontSize: 8 },
                       {
                         text: ` Mechanical Failure \n  `,
                         bold: true,
                         italics: true,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Mechanical Failure: Failure of a `,
                         fontSize: 8,
                       },
                       {
                         text: `covered part`,
                         bold: true,
                         italics: true,
                         fontSize: 8,
                       },
                       {
                         text: ` under normal use, not caused by non-covered parts \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Coverage applies only if: \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\ i) Purchased at time of sale/lease of the vehicle on the policy, or \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\ ii) Before expiry of original manufacturer’s warranty (with equal/lesser coverage)\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Coverage starts on the `,
                         fontSize: 8,
                       },
                       {
                         text: `'Start Date'`,
                         bold: true,
                         italics: true,
                         fontSize: 8,
                       },
                       {
                         text: ` noted on page one of this application and with a noted:\n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Warranty Authorization Number \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Signed agreement\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Proof of full payment recived on or before the date of the application \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  The 'term' ends when the 'end term date' has arrived on the calendar or the odometer limit (whichever comes first) is reached \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ This policy may be cancelled for non-payment at any time and at the discretion of Get Covered Canada Inc. and/or their authoized agent(s) \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ The vehicle under this policy must be in proper operating condition at program commencement date\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ False information shall VOID this agreement - and a $299.00 administrative fee will apply and be due by the policy holder in cases of this nature \n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `2. Vehicle Eligibility (Exclusions) \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Not eligible: \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ High-end or exotic vehicles (e.g., Ferrari, Lamborghini, Rolls-Royce, Bentley, Mclaren, Bugatti, etc.) \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Vehicles over 1-ton payload capacity \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Vehicles used for:\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Taxi, courier, chauffeuring, UBER/Ride-sharing, delivery, snowplowing, tow-truck, racing, police, ambulance, other emergency use purposed vehicles,  \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  food trucks, heavy use hauling \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Ineligible warranties will be cancelled and refunded through the purchasing  dealership.\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Total loss vehicles.\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Rebuilt vehicles.\n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `3. Maintenance Requirements \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Must follow manufacturer’s fluid and maintenance schedule. \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Oil & filter change every 10,000 km or or six (6) months, whichever comes sooner \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ DIY ('do it yourself') maintenance is `,
                         fontSize: 8,
                       },
                       { text: `NOT`, bold: true, italics: true, fontSize: 8 },
                       { text: ` allowed \n`, fontSize: 8 },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Maintenance documentation must include:\n`,
                     margin: [0, 5],
                     bold: false,
                   },
 
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Repair facility information\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Date, invoice/work order physical paperwork & number\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Vehicle details (VIN, make, model, year, km)\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Maintenance performed and cost in US or Canadian currency\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Proof of payment to an authorized oil change/mechanic shop facility (made by credit card or debit only)\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Claims may be denied for neglecting any prescribed/scheduled vehicle maintenance\n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `4. Warranty Plans and Coverage \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Based on selected plan:\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 `,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Essential/Bronze`,
                         fontSize: 8,
                         color: "#800000",
                         bold: true,
                       },
                       {
                         text: ` Powertrain Programs \n`,
                         fontSize: 8,
                         bold: true,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 `,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Essential/Silver`,
                         fontSize: 8,
                         color: "#808080",
                         bold: true,
                       },
                       {
                         text: ` Powertrain Plus Programs \n`,
                         fontSize: 8,
                         bold: true,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 `,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Premium/Gold`,
                         fontSize: 8,
                         color: "#996515",
                         bold: true,
                       },
                       {
                         text: ` Powertrain Plus Programs \n\n\n`,
                         fontSize: 8,
                         bold: true,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `5. Maximum Liabilities \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Based on numerous offered plans: \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	$1000 / $1500 / $2000/ $2500 / $3000 / $4000 / $5000 /$10,000 per claim \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ``,
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	OR`,
                         fontSize: 8,
                         bold: true,
                         italics: true,
                       },
                       {
                         text: ` half the vehicle purchase price (whichever is less)\n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Total term limit = purchase price of vehicle \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Any claim`,
                         fontSize: 8,
                       },
                       {
                         text: ` MUST`,
                         fontSize: 8,
                         bold: true,
                         italics: true,
                       },
                       {
                         text: ` be made with five business days of the issue being reported to a licensed mechanic!\n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Duly stated and noted on the first page of this policy/application\n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `6. Deductible \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	$199.00`,
                         bold: true,
                         fontSize: 8,
                         italics: true,
                       },
                       {
                         text: ` deductible applies to all (each and every) warranty claim as stated on the agreement front page. \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	All claims are subject to a 10% clawback amount deducted from the total claim amount; the clawback is processed prior to the $199.00 deductible \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\   being subtracted. \n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `7. Warranty Coverage Details \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
 
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Trip-Interruption:`,
                         bold: true,
                         fontSize: 8,
                       },
                       {
                         text: ` Up to $100/day, 5 days, 250km+ from home \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Rental Allowance:`,
                         bold: true,
                         fontSize: 8,
                       },
                       {
                         text: ` $40/day, 5 days; certain conditions apply! \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Diagnostics:`,
                         bold: true,
                         fontSize: 8,
                       },
                       {
                         text: ` Diagnostics are covered if the claim is validly covered by this Agreement (Maximum Diagnostic time deemed reasonable is one (1) hour) \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: `Includes: \n`,
                   //   margin: [0, 5],
                   //   bold: true,
                   // },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Air Conditioner \n`,
                     margin: [0, 5],
                     bold: true,
                   },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   margin: [0, 5],
                   //   bold: false,
                   //   text: [
                   //     {
                   //       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Seals & Gaskets`,
                   //       bold: true,
                   //       fontSize: 8,
                   //     },
                   //     { text: ` – Gaskets and seals are covered only when required as part of an approved repair. Minor leaks or fluid oozing are considered normal and are not covered. \n`, fontSize: 8 },
                   //   ],
                   // },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Electrical System:`,
                         bold: true,
                         fontSize: 8,
                       },
                       {
                         text: ` Switches, wipers, lights, mirrors, seat controls, etc.\n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: `Includes: \n`,
                   //   margin: [0, 5],
                   //   bold: true,
                   // },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Brakes\n`,
                     margin: [0, 5],
                     bold: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 ABS / Traction Control \n`,
                     margin: [0, 5],
                     bold: true,
                   },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Fuel Injection System\n`,
                   //   margin: [0, 5],
                   //   bold: true,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   margin: [0, 5],
                   //   bold: false,
                   //   text: [
                   //     {
                   //       text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Front Suspension`,
                   //       bold: true,
                   //       fontSize: 8,
                   //     },
                   //     {
                   //       text: ` (excludes shocks/air suspension) \n`,
                   //       fontSize: 8,
                   //     },
                   //   ],
                   // },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Power Steering \n\n\n`,
                     margin: [0, 5],
                     bold: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `8. How to Make a Claim \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `     or by phone at: 905-291-2940 within 24 hours of vehicle \n`,
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 1.	Call Get Covered Canada:`,
                         fontSize: 8,
                       },
                       {
                         text: ` Immediately report a claim to: `,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: `claims@getcoveredcanada.ca`,
                         fontSize: 8,
                         bold: true,
                         decoration: "underline",
                       },
                       {
                         text: ` or by phone at: 905-291-2940 within 24 hours of vehicle \n`,
                         fontSize: 8,
                         bold: true,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 breakdown \n`,
                     margin: [0, 5],
                     bold: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 2.	Provide maintenance documentation when instructed to do so \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 3.	A Get Covered Canada on-site claims adjuster may be required \n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Repair Coverage & Authorization \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Repair costs are based on average similar repairs or the MITCHELL GUIDE or similar manuals \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Only repairs authorized by Get Covered Canada are covered, and as such MUST be submitted PRIOR to any work being commenced/completed and \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 made within Section 5 limitations  \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Pre-Authorization granted only if: \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Terms & Conditions are met \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Agreement /term policy is active \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Cost estimate is acceptable and provided to Get Covered Canada by a licensed automotive facility \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Claim Authorization Number: \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Genreated  by Get Covered Canada and valid for 30 days \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Valid only for specified and authorized repair shops\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Get Covered Canada may use OEM, aftermarket, used, or rebuilt parts at its sole discretion \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 No coverage (policy is VOID) if  this policy agreement expires, is cancelled, or terminated before any work is completed! \n\n\n`,
                     margin: [0, 5],
                     bold: true,
                     italics: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` Payment process \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Claims shall be paid directly to licensed repair shop after: \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Claim Authorization Number has been issued \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Repairs are completed by authorized repair facility \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Final invoice signed and submitted by all parties involved\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Warranty Holder pays deductible, taxes, and non-covered items \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Reimbursement (in special cases only authorized in advance by Get Covered Canada): \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Must be pre-authorized \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Documents and receipts required within 5 business days \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Repairs outside Ontario evaluated per Ontario standards \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Reimbursements made in Canadian dollars \n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Warranty Coverage Exclusions \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Parts and labour not listed in Part 6 \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Pre-existing mechanical defects \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Unauthorized repairs or unauthorized locations \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Regular maintenance items (e.g., alignment, spark plugs, software updates) \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Electrical wiring, certain hardware, and accessories (e.g., heated seats, cameras) \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Failures from poor maintenance, abuse, or neglect \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Dirty oil, carbon buildup, or non-wear-based issues\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Failures from improper and/or contaminated fluids or lubricant issues \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Failures due to modified vehicles or non-OEM parts \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Wear-only issues (e.g., high oil consumption)\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Failures from accidents, weather, natural disasters, rodents, fire, vandalism, etc. \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Failures caused by non-covered parts\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Tampered odometers \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Failures already covered under other warranties or legal actions \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Time loss, inconvenience, or profit loss due to delays or failures \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Noises that don’t affect part or vehicle operation \n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: `"Claim Free Double Term Option” Extended Coverage Offer \n`,
                   //   margin: [0, 5],
                   //   bold: true,
                   //   fontSize: 13,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Applies to original owners of 1 - 4 year policies. \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Not applicable to transferred or renewed policies \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Warranty extensions or renewals are only available 30 days prior to the warranty's expiration date. \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Eligibility conditions: \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  1. Original GCC extended warranty holder/owner of vehicle only \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  2. All Agreement obligations must be met and substaniated with documentation as required/requested by Get Covered Canada \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  3. Submit all maintenance records upon registration \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  4. No previous claims (paid, authorized, or pending)\n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  5. Policy holder has contacted Get Covered Canada before original term ends \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  6. Pay $199.00 + HST and get oil change (if required). \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  7. NOTE: The second term has not cancellable and/or is not transferable or cash convertible \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  8. Coverage may differ from original policy \n\n\n\n\n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   {
                     fontSize: 13,
                     alignment: "left",
                     text: `Cancellations \n`,
                     margin: [0, 5],
                     bold: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Non-cancellable except within 10 days of purchase. \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Must go through selling dealer with no claims made \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 25% cancellation fee (minimum $100) + HST applies \n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 13,
                     alignment: "left",
                     text: `Claim Submission Limit and Mandatory Vehicle Inspection \n`,
                     margin: [0, 5],
                     bold: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `• Claim Submission Limit
       Customers are permitted to submit up to three (3) claims under their coverage without requiring a mandatory inspection.
       
       • Mandatory Inspection Requirement
       Upon submission of a third (3rd) claim, the covered vehicle will become subject to a mandatory inspection before any additional claims can be processed.
       
       • Inspection Prior to Fourth Claim Approval
       Before a fourth (4th) claim or any subsequent claim can be reviewed or approved, the vehicle must be inspected in person at Car Service Direct, located in Vaughan, Ontario, by an authorized mechanic.
       
       • Inspection Scheduling
       It is the responsibility of the customer to schedule and complete the inspection with Car Service Direct within a reasonable timeframe after the third claim is submitted.
       
       • Failure to Complete Inspection
       If the required inspection is not completed, any fourth or subsequent claim submission may be delayed, denied, or deemed ineligible for approval until the inspection requirement has been satisfied.
       
       • Condition Verification
       The purpose of the inspection is to verify the current condition of the vehicle, confirm previous repairs if applicable, and ensure compliance with coverage standards.
       
       • Right to Refuse Claims
       The company reserves the right to refuse, delay, or request additional documentation for any claim if the inspection requirement is not fulfilled.
       
       • Modification of Terms
       These terms may be updated or modified at the discretion of the company, with notice provided where required.
       
       By submitting a claim, the customer acknowledges and agrees to comply with these terms and conditions. \n
       `,
                     margin: [10, 5],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Total Loss Clause (For Finance Companies) \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Cancellation allowed if vehicle is: \n`,
                     margin: [0, 5],
                     bold: true,
                     italics: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Declared a total loss by the insurer\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Repossessed \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Refund based on amount paid by`,
                         fontSize: 8,
                         bold: true,
                         italics: true,
                       },
                       {
                         text: ` dealer,`,
                         fontSize: 10,
                         bold: true,
                         italics: true,
                       },
                       {
                         text: ` minus: \n`,
                         fontSize: 8,
                         bold: true,
                         italics: true,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 $100 admin fee \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Any claim payouts\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Refund schedule: \n`,
                     margin: [0, 5],
                     bold: true,
                     italics: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 1: 75% \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 2: 70%\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 3: 50%\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 4: 40% \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 5: 30% \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 6: 20% \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 7: 10% \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 8–12: 0% \n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Other Terms\n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    OMVIC Compliance:`,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Get Covered Canada Inc. O/A Get Covered Canada complies with all MVDA and UCDA guidelines, policies, and procedures; \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0     backed by letter of credit to OMVIC. \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Transferability: \n`,
                   //   margin: [0, 5],
                   //   bold: true,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    One-time transfer to new owner (same vehicle only) \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Notify Get Covered Canada by email within 10 days \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Provide registration & bill of sale \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	$199 + HST transfer fee required. \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Failure to pay will result in policy cancellation \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Financial Agreements: \n`,
                     margin: [0, 5],
                     bold: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Financing companies entitled to cancellation refunds \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Missed payments may lead to cancellation with no refund or claim \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Right to Recover:`,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Get Covered Canada can pursue third parties for reimbursed claims \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Territory:`,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Valid for repairs in Canada & United States of America \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Dispute Resolution:`,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Must follow binding arbitration via Canadian Arbitration Association (after written notice of dispute) \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Privacy:`,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Consent required for data collection, possibly outside Canada\n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Entire Agreement:`,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Supersedes all previous terms, conditions, and policies, written or oral \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Governing Laws:`,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Get Covered Canada is legally entiltled to operate business in Ontario, and as such is bound by the laws within the province of \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 Ontario (provincially), and within the country of Canada, abiding by all federal laws \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                 ],
                 border: [true, true, true, true],
               },
             ]
             : [
               {
                 text: [
                   // {
                   //     fontSize: 8, alignment: 'left', text: `Extended Warranty Program – Terms & Conditions \n`, margin: [0, 5], bold: true
                   // },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Extended Warranty Program – Terms & Conditions \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 20,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Issued by: GET COVERED CANADA INC. \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 8,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Updated: August 2025 \n\n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 8,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Extended Warranty Agreement Overview \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ The full Agreement includes both the Extended Warranty Application/Registration Page & Terms and Conditions of the policy \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Only documents provided to the policy holder directly by Get Covered Canada are valid \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Please keep a copy as proof of coverage for the full term of the policy \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Only listed parts, labour, and specified benefits are covered \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   // {
                   //     fontSize: 8, alignment: 'left', text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ This is an Inclusionary Mechanical Breakdown Warranty, not a service agreement or contract \n\n\n`, margin: [0, 5], bold: false
                   // },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: " \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0 This is an ",
                         fontSize: 8,
                       },
                       {
                         text: "Inclusionary Mechanical Breakdown Warranty, ",
                         bold: true,
                         italics: true,
                         fontSize: 8,
                       },
                       {
                         text: "not a service agreement or contract \n\n\n",
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `1. Essential Warranty Plans \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0 Get Covered Canada Inc. will cover reasonable repair costs for `,
                         fontSize: 8,
                       },
                       {
                         text: `Covered Parts `,
                         bold: true,
                         italics: true,
                         fontSize: 8,
                       },
                       { text: `due to`, fontSize: 8 },
                       {
                         text: ` Mechanical Failure \n  `,
                         bold: true,
                         italics: true,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Mechanical Failure: Failure of a `,
                         fontSize: 8,
                       },
                       {
                         text: `covered part`,
                         bold: true,
                         italics: true,
                         fontSize: 8,
                       },
                       {
                         text: ` under normal use, not caused by non-covered parts \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Coverage applies only if: \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\ i) Purchased at time of sale/lease of the vehicle on the policy, or \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\ ii) Before expiry of original manufacturer’s warranty (with equal/lesser coverage)\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Coverage starts on the `,
                         fontSize: 8,
                       },
                       {
                         text: `'Start Date'`,
                         bold: true,
                         italics: true,
                         fontSize: 8,
                       },
                       {
                         text: ` noted on page one of this application and with a noted:\n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Warranty Authorization Number \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Signed agreement\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Proof of full payment recived on or before the date of the application \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  The 'term' ends when the 'end term date' has arrived on the calendar or the odometer limit (whichever comes first) is reached \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ This policy may be cancelled for non-payment at any time and at the discretion of Get Covered Canada Inc. and/or their authoized agent(s) \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ The vehicle under this policy must be in proper operating condition at program commencement date\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ False information shall VOID this agreement - and a $299.00 administrative fee will apply and be due by the policy holder in cases of this nature \n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `2. Vehicle Eligibility (Exclusions) \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Not eligible: \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ High-end or exotic vehicles (e.g., Ferrari, Lamborghini, Rolls-Royce, Bentley, Mclaren, Bugatti, etc.) \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Vehicles over 1-ton payload capacity \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Vehicles used for:\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Taxi, courier, chauffeuring, UBER/Ride-sharing, delivery, snowplowing, tow-truck, racing, police, ambulance, other emergency use purposed vehicles,  \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  food trucks, heavy use hauling \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Ineligible warranties will be cancelled and refunded through the purchasing  dealership.\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Total loss vehicles.\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Rebuilt vehicles.\n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `3. Maintenance Requirements \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Must follow manufacturer’s fluid and maintenance schedule. \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Oil & filter change every 10,000 km or or six (6) months, whichever comes sooner \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ DIY ('do it yourself') maintenance is `,
                         fontSize: 8,
                       },
                       { text: `NOT`, bold: true, italics: true, fontSize: 8 },
                       { text: ` allowed \n`, fontSize: 8 },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Maintenance documentation must include:\n`,
                     margin: [0, 5],
                     bold: false,
                   },
 
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Repair facility information\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Date, invoice/work order physical paperwork & number\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Vehicle details (VIN, make, model, year, km)\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Maintenance performed and cost in US or Canadian currency\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Proof of payment to an authorized oil change/mechanic shop facility (made by credit card or debit only)\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\ Claims may be denied for neglecting any prescribed/scheduled vehicle maintenance\n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `4. Warranty Plans and Coverage \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Based on selected plan:\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 `,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Essential/Bronze`,
                         fontSize: 8,
                         color: "#800000",
                         bold: true,
                       },
                       {
                         text: ` Powertrain Programs \n`,
                         fontSize: 8,
                         bold: true,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 `,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Essential/Silver`,
                         fontSize: 8,
                         color: "#808080",
                         bold: true,
                       },
                       {
                         text: ` Powertrain Plus Programs \n`,
                         fontSize: 8,
                         bold: true,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 `,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Premium/Gold`,
                         fontSize: 8,
                         color: "#996515",
                         bold: true,
                       },
                       {
                         text: ` Powertrain Plus Programs \n\n\n`,
                         fontSize: 8,
                         bold: true,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `5. Maximum Liabilities \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Based on numerous offered plans: \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	$1000 / $1500 / $2000/ $2500 / $3000 / $4000 / $5000 /$10,000 per claim \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ``,
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	OR`,
                         fontSize: 8,
                         bold: true,
                         italics: true,
                       },
                       {
                         text: ` half the vehicle purchase price (whichever is less)\n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Total term limit = purchase price of vehicle \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Any claim`,
                         fontSize: 8,
                       },
                       {
                         text: ` MUST`,
                         fontSize: 8,
                         bold: true,
                         italics: true,
                       },
                       {
                         text: ` be made with five business days of the issue being reported to a licensed mechanic!\n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Duly stated and noted on the first page of this policy/application\n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `6. Deductible \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: false,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	$199.00`,
                         bold: true,
                         fontSize: 8,
                         italics: true,
                       },
                       {
                         text: ` deductible applies to all (each and every) warranty claim as stated on the agreement front page. \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	All claims are subject to a 10% clawback amount deducted from the total claim amount; the clawback is processed prior to the $199.00 deductible \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\   being subtracted. \n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
 
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `7. Warranty Coverage Details \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 This Agreement provides `,
                         bold: false,
                         fontSize: 8,
                       },
                       {
                         text: "named-component coverage only",
                         bold: true,
                         fontSize: 8,
                       },
                       {
                         text: ` and is not comprehensive or "bumper-to-bumper" coverage. Coverage is limited to the plan \n`,
                         bold: false,
                         fontSize: 8,
                       },
                     ],
                     margin: [0, 5],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 selected on the front page of this Agreement and the components marked for that plan in the applicable Coverage Schedule.\n `,
                     margin: [20, 5, 0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: " \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022  Essential Warranty Programs \n",
                     margin: [20, 5, 0, 5],
                     bold: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: " \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Bronze: ",
                     margin: [35, 5, 0, 5],
                     bold: true,
                   },
                   {
                     text: " Entry-level coverage. Includes only components marked in the Bronze column, with claim limits of $1,000 or $1,500. \n",
                     bold: false,
                     fontSize: 8,
                   },
 
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: " \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Silver: ",
                     margin: [35, 5, 0, 5],
                     bold: true,
                   },
                   {
                     text: " Enhanced Essential coverage. Includes only components marked in the Silver column, with claim limits of $2,500, $4,000 or $5,000. \n",
                     bold: false,
                     fontSize: 8,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Premium Protection Plans\n`,
                     margin: [0, 5],
                     bold: true,
                   },
 
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: " \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Core: ",
                     margin: [35, 5, 0, 5],
                     bold: true,
                   },
                   {
                     text: " Entry-level Premium coverage. Includes only components marked in the Core column, with coverage up to the selected claim limit. \n",
                     bold: false,
                     fontSize: 8,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: " \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Elite: ",
                     margin: [35, 5, 0, 5],
                     bold: true,
                   },
                   {
                     text: " Broader Premium coverage. Includes applicable Core components plus additional components marked in the Elite column. \n",
                     bold: false,
                     fontSize: 8,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: " \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Elite Hi-Tech: ",
                     margin: [35, 5, 0, 5],
                     bold: true,
                   },
                   {
                     text: " Our highest coverage level. Includes applicable Elite components plus eligible high-technology components marked in the Elite  \n",
                     bold: false,
                     fontSize: 8,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: " \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 Hi-Tech column, with coverage up to the selected claim limit. \n ",
                     margin: [35, 5, 0, 5],
                     bold: false,
                   },
 
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 A checkmark applies only to the plan column in which it appears. Purchasing a lower-level plan does not provide coverage for components listed \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 under a higher-level plan.\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Benefits, limits, deductibles, exclusions and conditions vary by plan.\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022 Please refer to the applicable coverage brochure or contact our Claims Department at`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     text: " 905-291-2940 ",
                     bold: true,
                     fontSize: 8,
                     color: "blue",
                   },
                   {
                     text: " or ",
                     bold: true,
                     fontSize: 8,
                   },
                   {
                     text: " claims@getcoveredcanada.ca",
                     bold: true,
                     fontSize: 8,
                     color: "blue",
                   },
                   {
                     text: " \n ",
                     bold: true,
                     fontSize: 8,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 for further information regarding your specific policy coverage.\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `8. How to Make a Claim \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `     or by phone at: 905-291-2940 within 24 hours of vehicle \n`,
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 1.	Call Get Covered Canada:`,
                         fontSize: 8,
                       },
                       {
                         text: ` Immediately report a claim to: `,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: `claims@getcoveredcanada.ca`,
                         fontSize: 8,
                         bold: true,
                         decoration: "underline",
                       },
                       {
                         text: ` or by phone at: 905-291-2940 within 24 hours of vehicle \n`,
                         fontSize: 8,
                         bold: true,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 breakdown \n`,
                     margin: [0, 5],
                     bold: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 2.	Provide maintenance documentation when instructed to do so \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 3.	A Get Covered Canada on-site claims adjuster may be required \n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Repair Coverage & Authorization \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Repair costs are based on average similar repairs or the MITCHELL GUIDE or similar manuals \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Only repairs authorized by Get Covered Canada are covered, and as such MUST be submitted PRIOR to any work being commenced/completed and \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 made within Section 5 limitations  \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Pre-Authorization granted only if: \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Terms & Conditions are met \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Agreement /term policy is active \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Cost estimate is acceptable and provided to Get Covered Canada by a licensed automotive facility \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Claim Authorization Number: \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Genreated  by Get Covered Canada and valid for 30 days \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Valid only for specified and authorized repair shops\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Get Covered Canada may use OEM, aftermarket, used, or rebuilt parts at its sole discretion \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 No coverage (policy is VOID) if  this policy agreement expires, is cancelled, or terminated before any work is completed! \n\n\n`,
                     margin: [0, 5],
                     bold: true,
                     italics: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` Payment process \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Claims shall be paid directly to licensed repair shop after: \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Claim Authorization Number has been issued \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Repairs are completed by authorized repair facility \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Final invoice signed and submitted by all parties involved\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Warranty Holder pays deductible, taxes, and non-covered items \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Reimbursement (in special cases only authorized in advance by Get Covered Canada): \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Must be pre-authorized \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Documents and receipts required within 5 business days \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Repairs outside Ontario evaluated per Ontario standards \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Reimbursements made in Canadian dollars \n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Warranty Coverage Exclusions \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Parts and labour not listed in Part 6 \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Pre-existing mechanical defects \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Unauthorized repairs or unauthorized locations \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Regular maintenance items (e.g., alignment, spark plugs, software updates) \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Electrical wiring, certain hardware, and accessories (e.g., heated seats, cameras) \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Failures from poor maintenance, abuse, or neglect \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Dirty oil, carbon buildup, or non-wear-based issues\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Failures from improper and/or contaminated fluids or lubricant issues \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Failures due to modified vehicles or non-OEM parts \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Wear-only issues (e.g., high oil consumption)\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Failures from accidents, weather, natural disasters, rodents, fire, vandalism, etc. \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Failures caused by non-covered parts\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Tampered odometers \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Failures already covered under other warranties or legal actions \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Time loss, inconvenience, or profit loss due to delays or failures \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Noises that don’t affect part or vehicle operation \n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `"Claim Free Double Term Option” Extended Coverage Offer \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Applies to original owners of 1 - 4 year policies. \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Not applicable to transferred or renewed policies \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Warranty extensions or renewals are only available 30 days prior to the warranty's expiration date. \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Eligibility conditions: \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  1. Original GCC extended warranty holder/owner of vehicle only \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  2. All Agreement obligations must be met and substaniated with documentation as required/requested by Get Covered Canada \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  3. Submit all maintenance records upon registration \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  4. No previous claims (paid, authorized, or pending)\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  5. Policy holder has contacted Get Covered Canada before original term ends \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  6. Pay $199.00 + HST and get oil change (if required). \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  7. NOTE: The second term has not cancellable and/or is not transferable or cash convertible \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\  8. Coverage may differ from original policy \n\n\n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 13,
                     alignment: "left",
                     text: `Cancellations \n`,
                     margin: [0, 5],
                     bold: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Non-cancellable except within 10 days of purchase. \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Must go through selling dealer with no claims made \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 25% cancellation fee (minimum $100) + HST applies \n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 13,
                     alignment: "left",
                     text: `Claim Submission Limit and Mandatory Vehicle Inspection \n`,
                     margin: [0, 5],
                     bold: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `• Claim Submission Limit
       Customers are permitted to submit up to three (3) claims under their coverage without requiring a mandatory inspection.
       
       • Mandatory Inspection Requirement
       Upon submission of a third (3rd) claim, the covered vehicle will become subject to a mandatory inspection before any additional claims can be processed.
       
       • Inspection Prior to Fourth Claim Approval
       Before a fourth (4th) claim or any subsequent claim can be reviewed or approved, the vehicle must be inspected in person at Car Service Direct, located in Vaughan, Ontario, by an authorized mechanic.
       
       • Inspection Scheduling
       It is the responsibility of the customer to schedule and complete the inspection with Car Service Direct within a reasonable timeframe after the third claim is submitted.
       
       • Failure to Complete Inspection
       If the required inspection is not completed, any fourth or subsequent claim submission may be delayed, denied, or deemed ineligible for approval until the inspection requirement has been satisfied.
       
       • Condition Verification
       The purpose of the inspection is to verify the current condition of the vehicle, confirm previous repairs if applicable, and ensure compliance with coverage standards.
       
       • Right to Refuse Claims
       The company reserves the right to refuse, delay, or request additional documentation for any claim if the inspection requirement is not fulfilled.
       
       • Modification of Terms
       These terms may be updated or modified at the discretion of the company, with notice provided where required.
       
       By submitting a claim, the customer acknowledges and agrees to comply with these terms and conditions. \n
       `,
                     margin: [10, 5],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Total Loss Clause (For Finance Companies) \n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Cancellation allowed if vehicle is: \n`,
                     margin: [0, 5],
                     bold: true,
                     italics: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Declared a total loss by the insurer\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Repossessed \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Refund based on amount paid by`,
                         fontSize: 8,
                         bold: true,
                         italics: true,
                       },
                       {
                         text: ` dealer,`,
                         fontSize: 10,
                         bold: true,
                         italics: true,
                       },
                       {
                         text: ` minus: \n`,
                         fontSize: 8,
                         bold: true,
                         italics: true,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 $100 admin fee \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Any claim payouts\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Refund schedule: \n`,
                     margin: [0, 5],
                     bold: true,
                     italics: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 1: 75% \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 2: 70%\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 3: 50%\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 4: 40% \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 5: 30% \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 6: 20% \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 7: 10% \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022\u00A0\u00A0 Month 8–12: 0% \n\n\n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: `Other Terms\n`,
                     margin: [0, 5],
                     bold: true,
                     fontSize: 13,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    OMVIC Compliance:`,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Get Covered Canada Inc. O/A Get Covered Canada complies with all MVDA and UCDA guidelines, policies, and procedures; \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0     backed by letter of credit to OMVIC. \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Transferability: \n`,
                   //   margin: [0, 5],
                   //   bold: true,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    One-time transfer to new owner (same vehicle only) \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Notify Get Covered Canada by email within 10 days \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Provide registration & bill of sale \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	$199 + HST transfer fee required. \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   // {
                   //   fontSize: 8,
                   //   alignment: "left",
                   //   text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Failure to pay will result in policy cancellation \n`,
                   //   margin: [0, 5],
                   //   bold: false,
                   // },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Financial Agreements: \n`,
                     margin: [0, 5],
                     bold: true,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Financing companies entitled to cancellation refunds \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022	Missed payments may lead to cancellation with no refund or claim \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Right to Recover:`,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Get Covered Canada can pursue third parties for reimbursed claims \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Territory:`,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Valid for repairs in Canada & United States of America \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Dispute Resolution:`,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Must follow binding arbitration via Canadian Arbitration Association (after written notice of dispute) \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Privacy:`,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Consent required for data collection, possibly outside Canada\n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Entire Agreement:`,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Supersedes all previous terms, conditions, and policies, written or oral \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     margin: [0, 5],
                     bold: true,
                     text: [
                       {
                         text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u2022    Governing Laws:`,
                         fontSize: 8,
                         bold: true,
                       },
                       {
                         text: ` Get Covered Canada is legally entiltled to operate business in Ontario, and as such is bound by the laws within the province of \n`,
                         fontSize: 8,
                       },
                     ],
                   },
                   {
                     fontSize: 8,
                     alignment: "left",
                     text: ` \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 Ontario (provincially), and within the country of Canada, abiding by all federal laws \n`,
                     margin: [0, 5],
                     bold: false,
                   },
                 ],
                 border: [true, true, true, true],
               },
             ]),
       ],
       watermark:
         data.Status === "Cancelled"
           ? {
             text: "CANCELLED",
             color: "red",
             opacity: 0.2,
             bold: true,
             fontSize: 60,
           }
           : null,
 
     };
 
     // Generate the PDF and open it in a new tab
     pdfMake.createPdf(docDefinition).open();
   };

  const [dataList, setDataList] = useState(""); // Initialize with dummy data

  const warrantyData = [
    {
      id: 1,
      packages: 4,
      packagesTypes: 0,
      productIndex: 7,
      productCost: "519",
      packagesText: "Gap Financial Protection bundle",
      productName:
        "GAP Financial Protection Bundle - Max Liability: $75,000 - Financed Amt: $0 - $75,000 (96 Months/unlimted)",
      vinNo: "2589",
      vinNoText: "2589",
      make: "BMW",
      makeText: "BMW",
      model: "X1",
      modelText: "X1",
      year: 1998,
      yearText: 1998,
      odometer: "25000",
      odometerText: "25000",
      salePriceofVehicle: "5222",
      salePriceofVehicleText: "5222",
      comprehensiveFactoryWarrantyValid: "Yes",
      comprehensiveFactoryWarrantyValidText: "Yes",
      serviceDate: "2024-10-01",
      serviceDateText: "2024-10-01",
      warrantyClass: "Essential GCC",
      warrantyClassText: "Essential GCC",
      warrantyType: "Interior Shield",
      warrantyTypeText: "Interior Shield",
      warrantyProtection: "Extended",
      warrantyProtectionText: "Extended",
      warrantyOption: "1",
      warrantyOptionText: "1",
      highRatioCoverage: "Yes",
      highRatioCoverageText: "Yes",
      deductible: "$0 Deductible",
      deductibleText: "$0 Deductible",
      customerFirstName: "Manoj",
      customerFirstNameText: "Manoj",
      customerLastName: "Nayak",
      customerLastNameText: "Nayak",
      streetAddress: "kodila",
      streetAddressText: "kodila",
      town: "mangalore",
      townText: "mangalore",
      province: "British Columbia",
      provinceText: "British Columbia",
      postalCode: "857485",
      postalCodeText: "857485",
      customerPhone: "8574859685",
      customerPhoneText: "8574859685",
      customerEmail: "Abhi@gmail.com",
      customerEmailText: "Abhi@gmail.com",
      driverLicence: "78596",
      driverLicenceText: "78596",
      customerLanguage: "Francais",
      customerLanguageText: "Francais",
      dealNotes: "89655",
      dealNotesText: "89655",
      vinCust: "",
      vinCustText: "",
      salePriceofVehicleCust: "5222",
      salePriceofVehicleCustText: "5222",
      financeCompany: "mangalore",
      financeCompanyText: "mangalore",
      vehicleDeliveryDate: "2024-10-01",
      vehicleDeliveryDateText: "2024-10-01",
      warrantySoldFor: "966666666666666",
      warrantySoldForText: "966666666666666",
    },
    {
      id: 2,
      packages: 4,
      packagesTypes: 0,
      productIndex: 3,
      productCost: "519",
      packagesText: "Gap Financial Protection bundle",
      productName:
        "GAP Financial Protection Bundle - Max Liability: $75,000 - Financed Amt: $0 - $75,000 (96 Months/unlimted)",
      vinNo: "258888888888",
      vinNoText: "258888888888",
      make: "Mercedes",
      makeText: "Mercedes",
      model: "C-Class",
      modelText: "C-Class",
      year: 2000,
      yearText: 2000,
      odometer: "25000",
      odometerText: "25000",
      salePriceofVehicle: "5222",
      salePriceofVehicleText: "5222",
      comprehensiveFactoryWarrantyValid: "No",
      comprehensiveFactoryWarrantyValidText: "No",
      serviceDate: "2024-10-01",
      serviceDateText: "2024-10-01",
      warrantyClass: "Appearnce Packages",
      warrantyClassText: "Appearnce Packages",
      warrantyType: "Rust Shield",
      warrantyTypeText: "Rust Shield",
      warrantyProtection: "Extended",
      warrantyProtectionText: "Extended",
      warrantyOption: "1",
      warrantyOptionText: "1",
      highRatioCoverage: "Yes",
      highRatioCoverageText: "Yes",
      deductible: "$0 Deductible",
      deductibleText: "$0 Deductible",
      customerFirstName: "Arun",
      customerFirstNameText: "Arun",
      language: "0",
      languageText: "None",
      customerLastName: "Nayak",
      customerLastNameText: "Nayak",
      streetAddress: "mysore",
      streetAddressText: "mysore",
      town: "mangalore",
      townText: "mangalore",
      province: "British Columbia",
      provinceText: "British Columbia",
      postalCode: "857485",
      postalCodeText: "857485",
      customerPhone: "89685748596",
      customerPhoneText: "89685748596",
      customerEmail: "arun@gmail.com",
      customerEmailText: "arun@gmail.com",
      driverLicence: "87458596",
      driverLicenceText: "87458596",
      customerLanguage: "Francais",
      customerLanguageText: "Francais",
      dealNotes: "87458555",
      dealNotesText: "87458555",
      vinCust: "258888888888",
      vinCustText: "258888888888",
      salePriceofVehicleCust: "5222",
      salePriceofVehicleCustText: "5222",
      financeCompany: "mangalore",
      financeCompanyText: "mangalore",
      vehicleDeliveryDate: "2024-10-02",
      vehicleDeliveryDateText: "2024-10-02",
      warrantySoldFor: "966666666666666",
      warrantySoldForText: "966666666666666",
    },
  ];

  const loadData = async () => {
    setBackdropOpen(true);
    try {
      const response = await axios.post(URL, { dealership });

      if (response.data.status === 401) {
        setDataList(""); // Keep dummy data in case of unauthorized response
      } else {
        console.log(response.data.data);
        // setBackdropOpen(false);
        const responseData = response.data.data;
        const dataWithIndex =
          response.data.data.map((item, index) => ({
            ...item,
            slNo: index + 1, // Assign sequential SL No starting from 1
          })) || "";
        setDataList(dataWithIndex);
      }
    } catch (err) {
      console.log("Error fetching data:", err);
      // Use dummy data if request fails
      setDataList("");
    } finally {
      setBackdropOpen(false);
    }
  };

  const loadDateData = async () => {
    if (fromDate === "" || toDate === "") {
      alert("Both From Date and To Date cannot be empty!");
      return false;
    }

    if (new Date(toDate) <= new Date(fromDate)) {
      alert("To Date must be greater than From Date!");
      return false;
    } else {
      try {
        const response = await axios.post(URL, {
          dealership,
          fromDate,
          toDate,
        });

        if (response.data.status === 401) {
          setDataList(""); // Keep dummy data in case of unauthorized response
        } else {
          console.log(response.data.data);
          const responseData = response.data.data;
          const dataWithIndex =
            response.data.data.map((item, index) => ({
              slNo: index + 1, // Assign sequential SL No starting from 1
              ...item,
            })) || "";
          setDataList(dataWithIndex);
        }
      } catch (err) {
        console.log("Error fetching data:", err);
        // Use dummy data if request fails
        setDataList("");
      }
    }
  };
  const loadDataVin = async () => {
    try {
      const response = await axios.get(
        "https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/5UXWX7C5*BA?format=json&modelyear=2011",
      );

      // if (response.data.status === 401) {
      //     setDataList(""); // Keep dummy data in case of unauthorized response
      // } else {
      console.log(response);
      // const responseData = response.data.data;
      // // for (let i = 0; i < responseData.length; i++) {
      // //     responseData[i].id = i + 1;
      // // }
      // setDataList(responseData);
      // }
    } catch (err) {
      console.log("Error fetching data:", err);
      // Use dummy data if request fails
      // setDataList('');
    }
  };

  const EditData = (props) => {
    return (
      <Tooltip title="Edit">
        <EditIcon
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            ApplicationStore().setStorage("sideBarIndex", 3);
            setSidebarItemIndex(3);
            navigate("/BuildWarranty", {
              state: { type: "update", data: props.selectedRow },
            });
          }}
        />
      </Tooltip>
    );
  };

  const CopyData = (props) => {
    return (
      <ContentCopyIcon
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.stopPropagation();
          // navigate('/BuildWarranty', { state: { type: "update", data: props.selectedRow } });
          // if (props.selectedRow && typeof props.selectedRow === 'object') {
          //     // Clone the object to avoid mutating the original
          //     const updatedRow = { ...props.selectedRow };

          //     // Check if the key 'Status' exists and update its value
          //     if (updatedRow.Status === 'Closed Won') {
          //         updatedRow.Status = 'Pending';
          //     }
          //     SaveAsPending(updatedRow);
          //     // console.log("Updated selected row:", updatedRow);
          // } else {
          //     // console.log("Invalid row data:", props.selectedRow);
          // }
          e.stopPropagation();
          ApplicationStore().setStorage("sideBarIndex", 3);
          setSidebarItemIndex(3);
          navigate("/BuildWarranty", {
            state: { type: "recreate", data: props.selectedRow },
          });
        }}
      />
    );
  };

  const DeleteData = (props) => {
    return (
      <Tooltip title="Delete">
        <DeleteIcon
          onClick={() => {
            const isConfirmed = window.confirm(
              "Are you sure you want to delete?",
            );
            if (isConfirmed) {
              console.log(props.selectedRow.id);
              const data = {
                id: props.selectedRow.id,
                user: userName,
                VINNO: props.selectedRow.vinNo,
                dealership: props.selectedRow.dealership,
              };
              const mainURL =
                "./dealership/" + data.id + "/deletesByIdWarranty";
              serviceMethod(
                mainURL,
                "post",
                data,
                handleSuccess,
                handleException,
              );
            }
          }}
        />
      </Tooltip>
    );
  };

  const PrintData = (props) => {
    return (
      <Tooltip title="Print">
        <PrintIcon
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            // e.stopPropagation();
            // navigate('/PDFGen', { state: { type: "update", data: props.selectedRow } });
            generatePdf(props.selectedRow);
          }}
        />
      </Tooltip>
    );
  };

  const handleSubmit = (e) => {
    navigate("/AddDealership", { state: { type: "add", value: "" } });
    // const method = "POST";
    // const data = { oldPassword: currentPassword, newPassword, email: user_email };
    // const mainURL = URL;
    // serviceMethod(mainURL, method, data, handleSuccess, handleException);
  };

  let filteredRows = dataList;

  // Filter by VIN
  if (vinSearch) {
    filteredRows = filteredRows.filter((row) =>
      row.vinNo?.toLowerCase().includes(vinSearch.toLowerCase()),
    );
  }

  // Filter by Last Name
  if (lastName) {
    filteredRows = filteredRows.filter((row) =>
      row.customerLastNameText?.toLowerCase().includes(lastName.toLowerCase()),
    );
  }

  if (dealershipValue) {
    filteredRows = filteredRows.filter(
      (row) => row.dealership == dealershipValue, // Direct comparison for integers
    );
  }

  return (
    <div style={{ marginTop: "0px", padding: "0px" }}>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Box sx={{ flexGrow: 1, padding: "10px" }}>
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <FormControl fullWidth>
                <Typography variant="subtitle2">From Date</Typography>
                <TextField
                  // label="From Date"
                  variant="outlined"
                  type="date" // This makes the field accept only dates
                  id="joinDate"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  sx={{ marginBottom: 2 }} // Add some spacing below the input
                  fullWidth // Make it full width
                />
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl fullWidth>
                <Typography variant="subtitle2">To Date</Typography>
                <TextField
                  // label="From Date"
                  variant="outlined"
                  type="date" // This makes the field accept only dates
                  id="joinDate"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  sx={{ marginBottom: 2 }} // Add some spacing below the input
                  fullWidth // Make it full width
                />
              </FormControl>
            </Grid>

            <Grid item xs={4}>
              {userType == "admin" ? (
                <FormControl fullWidth required>
                  <Typography variant="subtitle2">Dealership</Typography>
                  <Autocomplete
                    // value={"dealershipText"}
                    options={dealershipArray}
                    onChange={(event, newValue) => handleDealership(newValue)} // Handle selection
                    getOptionLabel={(option) => option.accountName || ""} // Adjust to match the property you want to display
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    } // Adjust to match unique keys
                    sx={{ width: "100%" }} // Responsive width for the TextField
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Dealership" // Add a label for clarity
                      />
                    )}
                  />
                </FormControl>
              ) : (
                ""
              )}
            </Grid>
            <Grid item xs={2}>
              <Typography variant="subtitle2">Last Name</Typography>
              <TextField
                label="Search by Last Name"
                variant="outlined"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)} // Update search input
                sx={{ marginBottom: 2 }} // Add some spacing below the input
                fullWidth // Make it full width
              />
            </Grid>
            <Grid item xs={2}>
              <Typography variant="subtitle2">VIN No</Typography>
              <TextField
                label="Search by VIN"
                variant="outlined"
                value={vinSearch}
                onChange={(e) => setVinSearch(e.target.value)} // Update search input
                sx={{ marginBottom: 2 }} // Add some spacing below the input
                fullWidth // Make it full width
              />
            </Grid>
          </Grid>
        </Box>
        <Stack spacing={3}>
          <Stack direction="row" spacing={3}>
            <Stack spacing={1} sx={{ flex: "1 1 auto" }}>
              {/* <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 'medium',
                                    color: 'darknavy',
                                    fontFamily: 'Montserrat, sans-serif',
                                    display: 'flex',        // Align items in a row
                                    alignItems: 'center',   // Vertically center the icon and text
                                }}
                            >
                                <TaskIcon sx={{ fontSize: '20px' }} /> &nbsp;Pending warranty
                            </Typography> */}
              <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                {/* <Button color="inherit" 
                            onClick={(e) => handleSubmit(e)}
                            sx={{
                                backgroundColor: 'purple',
                                color:'white',  // Change background color to purple
                                '&:hover': {
                                    backgroundColor: 'purple',  // Darken the color on hover
                                },
                            }}
                            
                            startIcon={<AddIcon fontSize="var(--icon-fontSize-md)" />}>
                                Add Dealership
                            </Button> */}
                {/* <Button color="inherit" startIcon={<CloudDownloadIcon fontSize="var(--icon-fontSize-md)" />}>
                                Export
                            </Button> */}
              </Stack>
            </Stack>

            <div>
              {/* <Button startIcon={<AddIcon fontSize="var(--icon-fontSize-md)" />} variant="contained" onClick={toggleDrawer("right", true)}>
                                Add
                            </Button> */}
            </div>
          </Stack>
        </Stack>
        <br></br>
        {/* <Customer  toggleDrawer={toggleDrawer} state={state}  /> */}
        <DataGrid
          rows={filteredRows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
          experimentalFeatures={{ newEditingApi: false }}
          components={{
            Toolbar: () => (
              <Box
                sx={{
                  padding: 2,
                  display: "flex",
                  // justifyContent: 'flex-end', // Aligns to the left
                  borderBottom: "0.2px solid grey", // Adds bottom border
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "medium",
                    // fontSize: '16px', // Use fontSize instead of font
                    color: "darknavy",
                    fontFamily: "Montserrat, sans-serif", // Ensure proper font family syntax
                  }}
                >
                  Quote
                </Typography>
                <Button
                  color="inherit"
                  onClick={(e) => loadDateData(e)}
                  sx={{
                    backgroundColor: "#0d2365",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#0d2365",
                    },
                    borderRadius: "10px",
                    marginLeft: "auto", // Pushes the button to the right
                  }}
                // startIcon={<AddIcon fontSize="var(--icon-fontSize-md)" />}
                >
                  Fetch Data
                </Button>
                <Button
                  color="inherit"
                  onClick={(e) => loadData()}
                  sx={{
                    backgroundColor: "#0d2365",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#0d2365",
                    },
                    borderRadius: "10px",
                    marginLeft: "10px", // Pushes the button to the right
                  }}
                // startIcon={<AddIcon fontSize="var(--icon-fontSize-md)" />}
                >
                  Reset Data
                </Button>
              </Box>
            ),
          }}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              color: "darknavy", // Set column header text color to dark navy blue
              fontWeight: "bold", // Optional: Make column header text bold
            },
          }}
        />
        <Snackbar
          open={alertOpen}
          autoHideDuration={6000}
          onClose={handleCloseSnack}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
        <Backdrop
          sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
          open={backdropOpen}
        // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
    </div>
  );
}

export default ViewPendingWarranty;
